import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
var VeltPersistentCommentModeLabelPublicWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-persistent-comment-mode-label-public-wireframe", __assign({}, transformedProps), children));
};
export default VeltPersistentCommentModeLabelPublicWireframe;
